import CreateBreadCrumbs from './CreateBreadCrumbs';

export default CreateBreadCrumbs;
